import { breakpoints } from '../constants/breakpoints'

export default function isDesktop() {
   return window.innerWidth > breakpoints.sm
}
